// Temporary while country values are inconsistent
import { countryString } from '../validators/location';
import { getCountryValue } from './locations';

/**
 * @deprecated Use isSafePostOffice
 */
export const isPO = (location) => countryString(location.country) === 'POSTOFFICE';

/**
 * @deprecated Use isSafeUnitedStates
 */
export const isUS = (location) => countryString(location.country) === 'United States';

/**
 * @deprecated Use isSafeInternational
 */
export const isInternational = (location) => (location && !location.country) || (!isPO(location) && !isUS(location));

/**
 * This handles prop injection for Country Model.
 */
export const countryValueResolver = (props) => {
  const countryValue = getCountryValue(props.country);
  const commentsValue = (props.countryComments ? props.countryComments : props.country?.comments) ?? '';

  return {
    value: countryValue ? [countryValue] : [],
    comments: commentsValue,
  };
};
